import React, { useContext, useEffect } from "react";
import { AppContext } from "../util/AppContext";
import { getConfigValue } from "../util/getConfigValue";
import { useLocation, useNavigate, Link } from "react-router-dom";
import AlertModal from '../components/AlertModal';
import useComponentVisible from '../hooks/useComponentVisible';
import { useRoutingValidation } from "../util/useRoutingValidation";
import { useBreadcrumbs } from "../util/BreadcrumbContext";
import ProfessionalPrintingStepProgressBar, { ProfessionaPrintingStepIds } from "../components/ProfessionalPrintingStepProgressBar";

function SuccessfullySubmitPrintingRequest() {
    const [appState, setAppState] = useContext(AppContext);
    const alert = { type: 'success', heading: (getConfigValue(appState?.config?.ProfessionalPrinting?.SendToVendor?.Success?.Title, appState)?.Value || null), message: (getConfigValue(appState?.config?.ProfessionalPrinting?.SendToVendor?.Success?.Message, appState)?.Value || null) };

    const navigate = useNavigate();
    const { state } = useLocation();
    const [buttonRef, isDropdownVisible, setIsDropdownVisible] = useComponentVisible(false);
    const {setBreadcrumbs } = useBreadcrumbs();

    const returnToButtonLabel = state?.isQuickSheet 
        ? getConfigValue(appState.config?.GenerateDocumentPage?.ReturnToQuickSheetsButton, appState)?.Value
        : getConfigValue(appState.config?.GenerateDocumentPage?.DashboardButton, appState)?.Value;

	useEffect(() => {
		setBreadcrumbs([
			{ label: getConfigValue(appState.config?.Focus?.Header, appState)?.Value, path: "/FocusPage"}
		]);
	}, [setBreadcrumbs]);

    useRoutingValidation();

    function startNewSalesAid(startNew = true) {
        setAppState({
            ...appState,
            ...(startNew && {
                market: {},
                territory: {}
            }),
            prescriber: {},
            products: [],
            currentProduct: "",
            plans: [],
            category: "",
            mainMessage: "",
        });
        if (startNew) {
            navigate('/TerritoryPage');
        } else {
            navigate('/HCPPage');
        }
    }

    function handleClick() {
        setIsDropdownVisible(state => !state);
    }

    function handleReturn() {
        navigate(state?.returnURL, { state: { pdfURL: state?.pdfURL, fileName: state?.fileName, isQuickSheet: state?.isQuickSheet, quickSheetId: state?.quickSheetId } });
    }

    return (
        <>
            <ProfessionalPrintingStepProgressBar currentStepId={ProfessionaPrintingStepIds.COMPLETED} />

            <div className="container-lg mt-5">
                <div className="row justify-content-center">
                    <div className="col-11 col-md-8">
                        <div className="col-12">
                            <AlertModal alert={alert} />
                        </div>

                        <h2 className="type-20 my-4">{getConfigValue(appState.config?.ProfessionalPrinting?.SendToVendor?.OrderDetails?.Label, appState)?.Value || null}</h2>

                        <div className="card pd-card p-3 mb-5">
                            <div className="row d-flex align-items-center">
                                <div className="col-12 col-md-5">
                                    <h3 className="type-18 color-grey-d3 mb-4">{getConfigValue(appState.config?.ProfessionalPrinting?.SendToVendor?.DeliveryAddress?.Label, appState)?.Value || null}</h3>
                                </div>
                                <div className="col">
                                    <p className="my-0">
                                        <span className="type-bold d-block">{state.address.nickName}</span>
                                        <span className="d-block">{state.address.address1}</span>
                                        <span className="d-block">{state.address.address2}</span>
                                        <span className="d-block">{state.address.state}</span>
                                        <span className="d-block">{state.address.country}</span>
                                        <span className="d-block">{state.address.phoneNumber}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={`${state?.isQuickSheet ? "position-relative" : "row justify-content-center justify-content-lg-end mb-5"}`}>
                            {!state?.isQuickSheet && 
                            <div className="col-12 col-sm-9 col-md-7 col-lg-6 col-xl-5 order-lg-2">
                                <div className="dropdown dropup d-flex">
                                    <button
                                        onClick={handleClick}
                                        ref={buttonRef}
                                        className="btn btn-primary dropdown-toggle btn-lg pe-7 mb-3 mb-lg-0 ms-lg-3 pe-lg-3 flex-fill"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        {getConfigValue(appState.config?.GenerateDocumentPage?.NewButton, appState)?.Value}
                                    </button>
                                    <ul
                                        className="dropdown-menu dropdown-menu-end"
                                        style={{
                                            display: isDropdownVisible ? "block" : "none",
                                            position: "absolute",
                                            bottom: "48px",
                                        }}
                                    >
                                        <li className="mb-2">
                                            <span className="dropdown-item-text type-bold">
                                                {getConfigValue(appState.config?.GenerateDocumentPage?.NewButton?.Question, appState)?.Value}
                                            </span>
                                        </li>
                                        <li>
                                            <hr className="dropdown-divider" />
                                        </li>
                                        
                                        <li>
                                            <button type="button" to="#" className="dropdown-item" onClick={() => startNewSalesAid(false)}>
                                                {getConfigValue(appState.config?.GenerateDocumentPage?.NewButton?.KeepTerritory, appState)?.Value}
                                            </button>
                                        </li>
                                            
                                        <li>
                                            <button type="button" to="#" className="dropdown-item" onClick={() => startNewSalesAid()}>
                                                {getConfigValue(appState.config?.GenerateDocumentPage?.NewButton?.BrandNew, appState)?.Value}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            }

                            <div className={`${state?.isQuickSheet ? "position-absolute top-50 start-50 translate-middle mt-5" : "col-12 col-sm-9 col-md-7 col-lg-6 col-xl-5 order-lg-2"}`}>                                
                                <button className="btn btn-secondary btn-lg pe-7 pe-lg-3 flex-fill w-100" onClick={handleReturn}>
                                    {returnToButtonLabel}
                                </button>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SuccessfullySubmitPrintingRequest;